import React from 'react';
import { Button, Heading, Text } from '@makemydeal/dr-ui-bricks-components';

import { SHARE_CREDIT_APP_LINK_CONTENT } from './constants';
import { ShareCreditAppLinkRoot } from './shareCreditAppLink.style';

export const ShareCreditAppLink: React.FC<{ buyerFirstName: string; onSend: () => void }> = ({ buyerFirstName, onSend }) => (
    <ShareCreditAppLinkRoot data-testid="share-credit-app-link">
        <Heading as="h3" level={6} weight="regular">
            {SHARE_CREDIT_APP_LINK_CONTENT.heading}
        </Heading>
        <Text size="xsmall">{SHARE_CREDIT_APP_LINK_CONTENT.description(buyerFirstName)}</Text>
        <Button
            data-testid="share-credit-app-link-send-button"
            buttonStyle="secondary"
            buttonSize="small"
            width="100%"
            onClick={onSend}
        >
            {SHARE_CREDIT_APP_LINK_CONTENT.actionLabel}
        </Button>
    </ShareCreditAppLinkRoot>
);
